module.exports = __webpack_public_path__ + "media/images/v6/overlay-0913650150f3d189a86397eae70a12c4.png";